<template>
	<div class="advanced-container">
		<ModalHeader
			:title="title"
			:button-text="getString('save')"
			@click-button="saveClicked" />
		<div class="advanced-options">
			<AppList :items="items" >
				<template v-slot:carousel-option="{item}">
					<div class="row space-between">
						<p>{{ getString('carousel') }}</p>
						<AppSwitch :checked="category.carousel" @switched="(v) => category.carousel = v" />
					</div>
				</template>
			</AppList>
			<AppBottomSheet :forceWidth="bottomSheetWidth" :active="taxonomyChooserActive" @toggling-popup="toggleBottomSheet" >
				<TaxonomyChooser :category-temp-id="categoryTempId" v-if="taxonomyChooserActive" @close="taxonomyChooserActive = false" />
			</AppBottomSheet>
		</div>
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppList from "@/shared/components/AppList.vue";
import AppNumberInput from "@/shared/components/AppNumberInput.vue";

import {useLanguageStore} from "@/shared/stores";
import {useMenuStore, useUserStore, usePrintersStore} from "@/console-new/stores";
import AppSwitch from "@/shared/components/AppSwitch.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import TaxonomyChooser from "@/console-new/components/config/menu/TaxonomyChooser.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let menuStore = useMenuStore();
		let printersStore = usePrintersStore();
		let userStore = useUserStore();
		return {getString: languageStore.getString, menuStore, userStore, printersStore};
	},
	name: "OptionsCategoryEditor",
	emits: ["save-clicked"],
	mixins: [WindowWidth],
	components: {TaxonomyChooser, AppBottomSheet, AppButton, AppList, ModalHeader, AppNumberInput, AppSwitch},
	props: {
		categoryTempId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			taxonomyChooserActive: false,
		};
	},
	computed: {
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else if(this.windowWidth < 1080) {
				return "720px";
			} else if(this.windowWidth < 1440) {
				return "960px";
			} else {
				return "1280px";
			}
		},
		title() {
			return this.getString("title_category_options", [this.category.name]);
		},
		category() {
			return this.menuStore.modMenu.categories[this.categoryTempId];
		},
		items() {
			return [
				{title: this.getString('description'), textInput: true, placeholder: this.getString('description'), isTextArea: true, value: this.category.description ? this.category.description : null, callbackText: (v) => this.category.description = (v && v.length  > 0 ? v : null)},
				{title: this.getString('highlighted'), switch: true, active: this.category.featured, callback: (v) => this.category.featured = v},
				{title: this.getString('grid_mode'), switch: true, active: this.category.grid_mode, callback: (v) => this.category.grid_mode = v},
				{title: this.getString('expanded'), switch: true, active: !this.category.dropdown, callback: this.expandedToggle, dropdownSlot: "carousel-option"},
				{title: this.getString('taxonomy'), buttonTitle: this.getString('edit'), buttonDisabled: !this.category.menu_category_id, callbackButton: this.openTaxonomyChooser},
			];
		},
	},
	methods: {
		toggleBottomSheet(isOpen) {
			if(!isOpen) {
				this.taxonomyChooserActive = false;
			}
		},
		openTaxonomyChooser() {
			this.taxonomyChooserActive = true;
		},
		expandedToggle(active) {
			if (active) {
				this.category.dropdown = false;
			} else {
				this.category.dropdown = true;
				this.category.carousel = false;
			}
		},
		saveClicked() {
			this.$emit("save-clicked");
		}
	},
}
</script>

<style lang="scss" scoped>
.ml-auto {
	margin-left: auto;
}
</style>